import http from '@/utils/http';
const base_path = '/v2/tool/sceneSpecTag';

/**
 * 获取场景定向标签接口
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export const geSceneSpecTagApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};
